import { render, staticRenderFns } from "./UserPackageView.vue?vue&type=template&id=54c3b2cc&scoped=true"
import script from "./UserPackageView.vue?vue&type=script&lang=js"
export * from "./UserPackageView.vue?vue&type=script&lang=js"
import style0 from "./UserPackageView.vue?vue&type=style&index=0&id=54c3b2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3b2cc",
  null
  
)

export default component.exports